import { computed } from 'vue'
import { getRouteSeoKeys, normalizeRoutePath } from '~/constants/routeSeoKeys'
import { resolveSeoText, SITE_SEO_KEYS } from '~/utils/resolveSeoText'

/** 全站 TDK：路由映射 → 页面 SEO i18n → site.seo 兜底 */
export function useRoutePageSeo() {
  const route = useRoute()
  const { t, te, tm } = useI18n()

  const pageSeoKeys = computed(() => getRouteSeoKeys(normalizeRoutePath(route.path)))

  const title = computed(() => {
    const keys = pageSeoKeys.value
    return resolveSeoText(
      t,
      te,
      tm,
      keys?.titleKey,
      SITE_SEO_KEYS.title,
    )
  })

  const description = computed(() => {
    const keys = pageSeoKeys.value
    return resolveSeoText(
      t,
      te,
      tm,
      keys?.descriptionKey,
      SITE_SEO_KEYS.description,
    )
  })

  const keywords = computed(() => {
    const keys = pageSeoKeys.value
    return resolveSeoText(
      t,
      te,
      tm,
      keys?.keywordsKey,
      SITE_SEO_KEYS.keywords,
    )
  })

  useHead({
    title,
    meta: [
      { name: 'description', content: description },
      { name: 'keywords', content: keywords },
    ],
  })
}
